module.exports = __webpack_public_path__ + "img/icons_UI_icon_missed_mint.99ad6737.svg";